import axios from 'axios';

// IMPORTANT: Replace this with your actual API's base URL
// In a real app, this would come from an environment variable (.env file)
// const API_BASE_URL = 'https://webapi-zakiya.peocty.com/api'; 
const API_BASE_URL = 'https://webapi-zakiya.jacuji.com/api'; 

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Interceptor to add the auth token to every request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers['x-auth-token'] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


export default api;